import React from 'react';
import {defineMessages} from 'react-intl';
import {LayoutDetailsBlock} from '@igp/shared/components/layout';
import type {BackpackFilterKeys, BackpackViewModelKeys} from '@igp/shared/features/backpack';
import {DataGridBackpackServer, useBackpack} from '@igp/shared/features/backpack';
import {getNonEmptyValueValidator} from '@igp/shared/redux/view';
import {EntityType} from '@models';

const localized = defineMessages({
    title: {
        id: 'PlayerBackpackInfo_displayName',
        defaultMessage: 'Backpack Info',
    },
    emptyList: {
        id: 'PlayerBackpackInfo_emptyList',
        defaultMessage: 'Backpack is empty',
    },
});

type PlayerBackpackInfoProps = {
    uid: string;
};

export function PlayerBackpackInfo({uid}: PlayerBackpackInfoProps) {
    const keys: BackpackViewModelKeys[] = [
        'serial_number',
        'created_at.seconds',
        'bonus_status',
        'marketing_code',
        'bonus_name',
        'tool_label',
        'used_at.seconds',
        'value',
    ];
    const {items, rawItems, totalCount, searchFilter, handlePageChange, handlePageSizeChange, handleSortChange} = useBackpack({
        viewType: 'BackpackInfo',
        fields: keys,
        displayName: localized.title,
        defaultFilters: [{key: 'uid', value: uid}],
        defaultSorting: [{sort: 'desc', field: 'created_at.seconds'}],
        validateFilter: getNonEmptyValueValidator<BackpackFilterKeys>('uid'),
        backpackEntity: EntityType.Backpack,
    });

    return (
        <LayoutDetailsBlock
            title={localized.title}
            content={
                <DataGridBackpackServer
                    autoHeight={true}
                    columns={keys}
                    rows={items}
                    rawModels={rawItems}
                    rowCount={totalCount}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                    onSortModelChange={handleSortChange}
                    page={searchFilter?.paging?.page}
                    pageSize={searchFilter?.paging?.pageSize}
                    sortModel={searchFilter?.sorting}
                    emptyMessage={localized.emptyList}
                />
            }
        />
    );
}
